module.exports = __webpack_public_path__ + "static/media/smiley-smile-2.830c10d0.svg";